<script setup lang="ts">
import { ref } from 'vue';
import { directive as clickAway } from 'vue3-click-away';
import { Direction } from '@enums/direction.ts';

withDefaults(defineProps<{
  panelClass?: string,
  direction?: Direction,
}>(), {
  panelClass: '',
  direction: Direction.DOWN,
});

defineOptions({ directives: { clickAway } });

const isVisible = ref<boolean>(false);

const toggleTooltip = (): void => {
  isVisible.value = !isVisible.value;
};

const closeTooltip = (): void => {
  isVisible.value = false;
};
</script>

<template>
  <div class="v-tooltip-click">
    <div class="v-tooltip-click__trigger" @click.prevent.stop="toggleTooltip">
      <slot name="trigger" />
    </div>

    <span
      v-show="isVisible"
      v-click-away="closeTooltip"
      class="v-tooltip-click__panel"
      :class="panelClass"
    >
      <slot name="panel" :close="closeTooltip" />
    </span>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins/rem' as *;

.v-tooltip-click {
  position: relative;

  &__panel {
    z-index: 10;
    position: absolute;
    transition: all 0.3s;
    border: 1px solid $colorGray;
    border-radius: rem(4);
    box-shadow: 0 rem(4) rem(8) 0 rgba(0, 0, 0, 0.25);
    background-color: $colorWhite;
    padding: rem(16);
    white-space: nowrap;
  }
}
</style>
